/* eslint-disable no-unused-expressions */
/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable no-undef */
import secureLocalStorage from "react-secure-storage";
const user = JSON.parse(secureLocalStorage.getItem("profile"));
const name = user ? user.results.firstName + " " + user.results.lastName : "";
const approvers_position = user ? user.results.position : "";
export default (claim = { success: null, error: null, claims: [] }, action) => {
  switch (action.type) {
    case "GET_ALL_CLAIMS":
      return { ...claim, claims: action.payload };
    case "CREATE_CLAIM":
      return {
        ...claim,
        claims: [...claim.claims, action.payload],
      };
    case "APPROVE_BRANCH_CLAIM":
      return {
        ...claim,
        claims: claim.claims.map((obj) =>
          obj._id === action.payload
            ? {
                ...obj,
                status: "approved",
                approved_by: name,
                approvers_position,
              }
            : obj
        ),
      };
    case "DELETE_BRANCH_CLAIM":
      return {
        ...claim,
        claims: claim.claims.filter((data) => data._id !== action.payload),
      };
    case "CLEAR_CLAIM":
      return {
        ...claim,
        claims: claim.claims.filter((data) => data._id !== action.payload),
      };
    default:
      return claim;
  }
};
